import portsApi from '@/framework/ports/portsApi';

const Footer = {
  hide: () => portsApi.invoke('Footer.hide'),
  show: () => portsApi.invoke('Footer.show'),
};

export default Footer;
